var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPwNonHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 14.1467C4.68804 13.3067 5.0926 12.1068 6.10929 11.5258C6.74861 11.1605 7.11333 10.4737 7.82418 10.0859C8.29344 9.82998 8.93266 9.53384 9.31257 9.19614C10.9963 7.69951 14.491 8.03131 16.6089 8.03131C20.1586 8.03131 26.0732 10.837 26.0732 15.0203",
    stroke: "#C1C1C7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4245 12.1074C10.3363 12.1074 11.2463 19.0964 15.2981 19.0964C16.9162 19.0964 18.616 17.5714 18.7926 15.8931C19.101 12.9632 17.758 12.1074 15.0069 12.1074",
    stroke: "#C1C1C7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPwNonHide);
export default __webpack_public_path__ + "static/media/icon-pw-non-hide.2d2c8796ae7b343929786ba6f3b6ed5b.svg";
export { ForwardRef as ReactComponent };